<template>
  <select
    ref="select"
    v-bind:id="this.id"
    v-bind:name="this.name"
    v-bind:style="this.cssStyle"
    v-bind:class="this.cssClass"
    v-bind:multiple="this.multiple"
  ></select>
</template>

<script>
export default {
  data: function() {
    return {
      selectedObject: null,
    };
  },
  props: {
    refObj: [String, Number, Object],
    cssStyle: String,
    cssClass: {
      type: String,
      default: "form-control form-control-sm",
    },
    id: {
      type: [String, Array],
      // required: true
    },
    name: String,
    multiple: {
      type: Boolean,
      default: false,
    },
    value: [String, Number, Array, Boolean],
    select2Options: {
      type: Object,
      required: true,
    },
  },
  methods: {
    clearData: function() {
      $(this.$refs.select).html("");
      this.$emit("input", this.value);
    },
    setSelectedData: function(data) {
      // create the option and append to Select2
      this.selectedObject = data;

      if (data) {
        var arrayOfData = [];

        if (Array.isArray(data)) {
          data = data.slice().sort(function(a, b) {
            return a.text.toLowerCase() > b.text.toLowerCase() ? 1 : -1;
          });
          arrayOfData = data;
        } else {
          arrayOfData.push(data);
        }

        for (let i = 0; i < arrayOfData.length; i++) {
          const optData = arrayOfData[i];
          var option = new Option(optData.text, optData.id, true, true);
          if ($("option[value=" + optData.id + "]", this.$refs.select).length == 0) {
            $(this.$refs.select).append(option);
          }
        }

        var selected = $.map(arrayOfData, function(optData, idx) {
          return optData.id;
        });

        // begin manage selectedObject
        var arrayOfObject = [];
        if (Array.isArray(this.selectedObject)) {
          arrayOfObject = this.selectedObject;
        } else {
          arrayOfObject.push(this.selectedObject);
        }
        this.selectedObject = null;
        // end manage selectedObject

        $(this.$refs.select)
          .val(selected)
          .trigger("change");

        // manually trigger the `select2:select` event
        // $(this.$refs.select)
        //   .trigger({
        //     type: "select2:select",
        //     params: {
        //       data: Array.isArray(data) ? arrayOfData : data
        //     }
        //   })
        //   .trigger("change");

        var data = $(this.$refs.select).select2("data");
        for (let i = 0; i < data.length; i++) {
          const d = data[i];
          // if (d.id == this.selectedObject.id) {
          //   $.extend(d, this.selectedObject);
          // }
          for (let j = 0; j < arrayOfObject.length; j++) {
            const obj = arrayOfObject[j];
            if (d.id == obj.id) {
              $.extend(d, obj);
              break;
            }
          }
        }
      }
    },
  },
  mounted: function() {
    var self = this;
    $(this.$refs.select)
      // init select2
      .select2(this.select2Options)
      .val(this.value)
      .trigger("change")
      // emit event on change.
      .on("change", function() {
        if (self.$props.multiple === true) {
          var selected = $.map($("option:selected", self.$refs.select), function(opt, idx) {
            return $(opt).val();
          });
          self.$emit("input", selected);
        } else {
          self.$emit("input", this.value);
        }
      });

    self.$emit("select2mounted", this.$refs.select);
  },
  watch: {
    value: function(value) {
      // update value
      if (this.selectedObject) {
        var arrayOfObject = [];

        if (Array.isArray(this.selectedObject)) {
          arrayOfObject = this.selectedObject;
        } else {
          arrayOfObject.push(this.selectedObject);
        }

        var data = $(this.$refs.select).select2("data");
        for (let i = 0; i < data.length; i++) {
          const d = data[i];
          // if (d.id == this.selectedObject.id) {
          //   $.extend(d, this.selectedObject);
          // }
          for (let j = 0; j < arrayOfObject.length; j++) {
            const obj = arrayOfObject[j];
            if (d.id == obj.id) {
              $.extend(d, obj);
              break;
            }
          }
        }

        this.selectedObject = null;
      } else {
        // $(this.$refs.select)
        //   .val(value)
        //   .trigger("change");

        this.$emit("selectChange", this.id, this.value, $(this.$refs.select).select2("data"), this.refObj);
      }
    },
  },
  destroyed: function() {
    $(this.$refs.select)
      .off()
      .select2("destroy");
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// App/Shared/Select2.vue